@if (isDesktop) {
  <div
    class="pref-items"
    [formGroup]="form">
    <div
      fxLayout="row"
      fxLayoutAlign="start top"
      style="width: 100%">
      <div class="pref-item-label">{{ 'NOTIFICATION-PREFERENCES.CONTACT-PREF-BY-SEVERITY-LABEL' | translate }}</div>
      @for (level of ratingScalelevels; track level.uId) {
        <div>
          <div class="pref-item-heading">
            <div
              class="severity-pill"
              [ngStyle]="{ 'background-color': level.htmlColorCode, 'color': level.textColor }">
              {{ level.label }}
            </div>
            <div class="severity-heading">{{ level.name }}</div>
            <div class="severity-details">{{ level.description }}</div>
          </div>
        </div>
      }
    </div>
    <!--
    Work and Personal section separators
    -->
    <div class="section-group-header is-work mt-5">
      {{ 'NOTIFICATION-PREFERENCES.WORK' | translate }}
    </div>
    <!--
    Preference setting labels
    -->
    @if (hasEmail) {
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        style="width: 100%">
        <div class="pref-label">
          <div class="type-label"><i class="icon icon-email"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.EMAIL' | translate }}</div>
        </div>
        <div class="pref-value">
          <ng-container [ngTemplateOutlet]="hasRequiredFields.work.email ? purpleCheck : dash"></ng-container>
        </div>
        <div class="pref-value">
          <ng-container [ngTemplateOutlet]="hasRequiredFields.work.email ? purpleCheck : dash"></ng-container>
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.work.email) {
            <topo-switch
            formControlName="use_work_email_moderate"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.work.email) {
            <topo-switch
            formControlName="use_work_email_low"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
    }
    @if (hasText) {
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        style="width: 100%">
        <div class="pref-label">
          <div class="type-label"><i class="icon icon-comment"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.TEXT-MESSAGE' | translate }}</div>
        </div>
        <div class="pref-value">
          <ng-container [ngTemplateOutlet]="hasRequiredFields.work.phone ? purpleCheck : dash"></ng-container>
        </div>
        <div class="pref-value">
          <ng-container [ngTemplateOutlet]="hasRequiredFields.work.phone ? purpleCheck : dash"></ng-container>
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.work.phone) {
            <topo-switch
            formControlName="use_work_text_moderate"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.work.phone) {
            <topo-switch
            formControlName="use_work_text_low"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
    }
    @if (hasPhone) {
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        style="width: 100%">
        <div class="pref-label is-phone-work">
          <div class="type-label"><i class="icon icon-phone_1"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.PHONE-CALL' | translate }}</div>
        </div>
        <div class="pref-value">
          <ng-container [ngTemplateOutlet]="hasRequiredFields.work.phone ? purpleCheck : dash"></ng-container>
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.work.phone) {
            <topo-switch
            formControlName="use_work_phone_call_high"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.work.phone) {
            <topo-switch
            formControlName="use_work_phone_call_moderate"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.work.phone) {
            <topo-switch
            formControlName="use_work_phone_call_low"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
    }
    @if (hasSlack) {
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        style="width: 100%">
        <div class="pref-label">
          <div class="type-label"><i class="icon icon-logo_slack"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.SLACK' | translate }}</div>
        </div>
        <div class="pref-value">
          <ng-container [ngTemplateOutlet]="hasRequiredFields.work.email ? purpleCheck : dash"></ng-container>
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.work.email) {
            <topo-switch
            formControlName="use_slack_high"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.work.email) {
            <topo-switch
            formControlName="use_slack_moderate"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.work.email) {
            <topo-switch
            formControlName="use_slack_low"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
    }
    @if (hasTeams) {
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        style="width: 100%">
        <div class="pref-label">
          <div class="type-label"><i class="icon icon-logo_ms_teams"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.MS-TEAMS' | translate }}</div>
        </div>
        <div class="pref-value">
          <ng-container [ngTemplateOutlet]="hasRequiredFields.work.email ? purpleCheck : dash"></ng-container>
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.work.email) {
            <topo-switch
            formControlName="use_teams_high"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.work.email) {
            <topo-switch
            formControlName="use_teams_moderate"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.work.email) {
            <topo-switch
            formControlName="use_teams_low"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
    }
    <div class="section-group-header is-personal">{{ 'NOTIFICATION-PREFERENCES.PERSONAL' | translate }}</div>
    @if (hasEmail) {
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        style="width: 100%">
        <div class="pref-label">
          <div class="type-label"><i class="icon icon-email"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.EMAIL' | translate }}</div>
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.personal.email) {
            <topo-switch
            formControlName="use_personal_email_extreme"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.personal.email) {
            <topo-switch
            formControlName="use_personal_email_high"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.personal.email) {
            <topo-switch
            formControlName="use_personal_email_moderate"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.personal.email) {
            <topo-switch
            formControlName="use_personal_email_low"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
    }
    @if (hasText) {
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        style="width: 100%">
        <div class="pref-label">
          <div class="type-label"><i class="icon icon-comment"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.TEXT-MESSAGE' | translate }}</div>
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.personal.phone) {
            <topo-switch
            formControlName="use_personal_text_extreme"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.personal.phone) {
            <topo-switch
            formControlName="use_personal_text_high"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.personal.phone) {
            <topo-switch
            formControlName="use_personal_text_moderate"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.personal.phone) {
            <topo-switch
            formControlName="use_personal_text_low"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
    }
    @if (hasPhone) {
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        style="width: 100%">
        <div class="pref-label">
          <div class="type-label"><i class="icon icon-phone_1"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.PHONE-CALL' | translate }}</div>
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.personal.phone) {
            <topo-switch
            formControlName="use_personal_phone_call_extreme"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.personal.phone) {
            <topo-switch
            formControlName="use_personal_phone_call_high"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.personal.phone) {
            <topo-switch
            formControlName="use_personal_phone_call_moderate"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.personal.phone) {
            <topo-switch
            formControlName="use_personal_phone_call_low"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
    }
    @if (hasWhatsApp) {
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        style="width: 100%">
        <div class="pref-label">
          <div class="type-label"><i class="icon icon-whatsapp"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.WHATS-APP' | translate }}</div>
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.whatsAppAddress) {
            <topo-switch
            formControlName="use_whats_app_extreme"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.whatsAppAddress) {
            <topo-switch
            formControlName="use_whats_app_high"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.whatsAppAddress) {
            <topo-switch
            formControlName="use_whats_app_moderate"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
        <div class="pref-value">
          @if (hasRequiredFields.whatsAppAddress) {
            <topo-switch
            formControlName="use_whats_app_low"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
    }
  </div>
} @else {
  <div
    class="pref-settings-container-mobile"
    [formGroup]="form">
    <div class="pref-item-label">{{ 'NOTIFICATION-PREFERENCES.CONTACT-PREF-BY-SEVERITY-LABEL' | translate }}</div>
    <!-- Extreme Options -->
    <div
      class="pref-item-group"
      (click)="toggleSection('extreme')">
      <div><i class="icon icon-small_bullhorn is-extreme"></i></div>
      <div
        fxLayout="column"
        fxLayoutAlign="start start"
        fxFlex="1 1 auto">
        <div class="severity-heading">{{ 'NOTIFICATION-PREFERENCES.MOBILE-EXTREME-HEADING' | translate }}</div>
        <div class="severity-desc">{{ 'NOTIFICATION-PREFERENCES.MOBILE-EXTREME-DESC' | translate }}</div>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center">
        <i
          class="icon icon-caret_down"
        [class.active]="display.extreme"></i>
      </div>
    </div>
    <div
      class="notification-options"
      [class.expanded]="display.extreme">
      <div class="section-group-header">
        {{ 'NOTIFICATION-PREFERENCES.WORK' | translate }}
      </div>
      <!-- Email -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-email"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.EMAIL' | translate }}</div>
        </div>
        <div>
          <ng-container [ngTemplateOutlet]="hasRequiredFields.work.email ? purpleCheck : dash"></ng-container>
        </div>
      </div>
      <!-- Text -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-comment"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.TEXT-MESSAGE' | translate }}</div>
        </div>
        <div>
          <ng-container [ngTemplateOutlet]="hasRequiredFields.work.phone ? purpleCheck : dash"></ng-container>
        </div>
      </div>
      <!-- Phone -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-phone_1"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.PHONE-CALL' | translate }}</div>
        </div>
        <div>
          <ng-container [ngTemplateOutlet]="hasRequiredFields.work.phone ? purpleCheck : dash"></ng-container>
        </div>
      </div>
      <!-- Slack -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-logo_slack"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.SLACK' | translate }}</div>
        </div>
        <div>
          <ng-container [ngTemplateOutlet]="hasRequiredFields.work.email ? purpleCheck : dash"></ng-container>
        </div>
      </div>
      <!-- MS Teams -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-logo_ms_teams"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.MS-TEAMS' | translate }}</div>
        </div>
        <div>
          <ng-container [ngTemplateOutlet]="hasRequiredFields.work.email ? purpleCheck : dash"></ng-container>
        </div>
      </div>
      <div class="section-group-header">
        {{ 'NOTIFICATION-PREFERENCES.PERSONAL' | translate }}
      </div>
      <!-- Email -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-email"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.EMAIL' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.personal.email) {
            <topo-switch
            formControlName="use_personal_email_extreme"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- Text -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-comment"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.TEXT-MESSAGE' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.personal.phone) {
            <topo-switch
            formControlName="use_personal_text_extreme"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- Phone -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-phone_1"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.PHONE-CALL' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.personal.phone) {
            <topo-switch
            formControlName="use_personal_phone_call_extreme"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- WhatsApp -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-whatsapp"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.WHATS-APP' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.whatsAppAddress) {
            <topo-switch
            formControlName="use_whats_app_extreme"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
    </div>
    <!-- High Options -->
    <div
      class="pref-item-group"
      (click)="toggleSection('high')">
      <div><i class="icon icon-small_bullhorn is-high"></i></div>
      <div
        fxLayout="column"
        fxLayoutAlign="start start"
        fxFlex="1 1 auto">
        <div class="severity-heading">{{ 'NOTIFICATION-PREFERENCES.MOBILE-HIGH-HEADING' | translate }}</div>
        <div class="severity-desc">{{ 'NOTIFICATION-PREFERENCES.MOBILE-HIGH-DESC' | translate }}</div>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center">
        <i
          class="icon icon-caret_down"
        [class.active]="display.high"></i>
      </div>
    </div>
    <div
      class="notification-options"
      [class.expanded]="display.high">
      <div class="section-group-header">
        {{ 'NOTIFICATION-PREFERENCES.WORK' | translate }}
      </div>
      <!-- Email -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-email"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.EMAIL' | translate }}</div>
        </div>
        <div>
          <ng-container [ngTemplateOutlet]="hasRequiredFields.work.email ? purpleCheck : dash"></ng-container>
        </div>
      </div>
      <!-- Text -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-comment"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.TEXT-MESSAGE' | translate }}</div>
        </div>
        <div>
          <ng-container [ngTemplateOutlet]="hasRequiredFields.work.phone ? purpleCheck : dash"></ng-container>
        </div>
      </div>
      <!-- Phone -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-phone_1"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.PHONE-CALL' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.work.phone) {
            <topo-switch
            formControlName="use_work_phone_call_high"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- Slack -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-logo_slack"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.SLACK' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.work.email) {
            <topo-switch
            formControlName="use_slack_high"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- MS Teams -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-logo_ms_teams"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.MS-TEAMS' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.work.email) {
            <topo-switch
            formControlName="use_slack_high"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <div class="section-group-header">
        {{ 'NOTIFICATION-PREFERENCES.PERSONAL' | translate }}
      </div>
      <!-- Email -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-email"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.EMAIL' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.personal.email) {
            <topo-switch
            formControlName="use_personal_email_high"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- Text -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-comment"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.TEXT-MESSAGE' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.personal.phone) {
            <topo-switch
            formControlName="use_personal_text_high"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- Phone -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-phone_1"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.PHONE-CALL' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.personal.phone) {
            <topo-switch
            formControlName="use_personal_phone_call_high"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- WhatsApp -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-whatsapp"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.WHATS-APP' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.whatsAppAddress) {
            <topo-switch
            formControlName="use_whats_app_high"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
    </div>
    <!-- Moderate Options -->
    <div
      class="pref-item-group"
      (click)="toggleSection('moderate')">
      <div><i class="icon icon-small_bullhorn is-moderate"></i></div>
      <div
        fxLayout="column"
        fxLayoutAlign="start start"
        fxFlex="1 1 auto">
        <div class="severity-heading">{{ 'NOTIFICATION-PREFERENCES.MOBILE-MODERATE-HEADING' | translate }}</div>
        <div class="severity-desc">{{ 'NOTIFICATION-PREFERENCES.MOBILE-MODERATE-DESC' | translate }}</div>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center">
        <i
          class="icon icon-caret_down"
        [class.active]="display.moderate"></i>
      </div>
    </div>
    <div
      class="notification-options"
      [class.expanded]="display.moderate">
      <div class="section-group-header">
        {{ 'NOTIFICATION-PREFERENCES.WORK' | translate }}
      </div>
      <!-- Email -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-email"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.EMAIL' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.work.email) {
            <topo-switch
            formControlName="use_work_email_moderate"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- Text -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-comment"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.TEXT-MESSAGE' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.work.phone) {
            <topo-switch
            formControlName="use_work_text_moderate"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- Phone -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-phone_1"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.PHONE-CALL' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.work.phone) {
            <topo-switch
            formControlName="use_work_phone_call_moderate"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- Slack -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-logo_slack"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.SLACK' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.work.email) {
            <topo-switch
            formControlName="use_slack_moderate"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- MS Teams -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-logo_ms_teams"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.MS-TEAMS' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.work.email) {
            <topo-switch
            formControlName="use_slack_moderate"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <div class="section-group-header">
        {{ 'NOTIFICATION-PREFERENCES.PERSONAL' | translate }}
      </div>
      <!-- Email -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-email"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.EMAIL' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.personal.email) {
            <topo-switch
            formControlName="use_personal_email_moderate"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- Text -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-comment"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.TEXT-MESSAGE' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.personal.phone) {
            <topo-switch
            formControlName="use_personal_text_moderate"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- Phone -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-phone_1"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.PHONE-CALL' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.personal.phone) {
            <topo-switch
            formControlName="use_personal_phone_call_moderate"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- WhatsApp -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-whatsapp"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.WHATS-APP' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.whatsAppAddress) {
            <topo-switch
            formControlName="use_whats_app_moderate"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
    </div>
    <!-- Low Options -->
    <div
      class="pref-item-group"
      (click)="toggleSection('low')">
      <div><i class="icon icon-small_bullhorn is-low"></i></div>
      <div
        fxLayout="column"
        fxLayoutAlign="start start"
        fxFlex="1 1 auto">
        <div class="severity-heading">{{ 'NOTIFICATION-PREFERENCES.MOBILE-LOW-HEADING' | translate }}</div>
        <div class="severity-desc">{{ 'NOTIFICATION-PREFERENCES.MOBILE-LOW-DESC' | translate }}</div>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center">
        <i
          class="icon icon-caret_down"
        [class.active]="display.low"></i>
      </div>
    </div>
    <div
      class="notification-options"
      [class.expanded]="display.low">
      <div class="section-group-header">
        {{ 'NOTIFICATION-PREFERENCES.WORK' | translate }}
      </div>
      <!-- Email -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-email"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.EMAIL' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.work.email) {
            <topo-switch
            formControlName="use_work_email_low"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- Text -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-comment"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.TEXT-MESSAGE' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.work.phone) {
            <topo-switch
            formControlName="use_work_text_low"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- Phone -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-phone_1"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.PHONE-CALL' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.work.phone) {
            <topo-switch
            formControlName="use_work_phone_call_low"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- Slack -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-logo_slack"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.SLACK' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.work.email) {
            <topo-switch
            formControlName="use_slack_low"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- MS Teams -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-logo_ms_teams"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.MS-TEAMS' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.work.email) {
            <topo-switch
            formControlName="use_slack_low"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <div class="section-group-header">
        {{ 'NOTIFICATION-PREFERENCES.PERSONAL' | translate }}
      </div>
      <!-- Email -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-email"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.EMAIL' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.personal.email) {
            <topo-switch
            formControlName="use_personal_email_low"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- Text -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-comment"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.TEXT-MESSAGE' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.personal.phone) {
            <topo-switch
            formControlName="use_personal_text_low"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- Phone -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-phone_1"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.PHONE-CALL' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.personal.phone) {
            <topo-switch
            formControlName="use_personal_phone_call_low"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
      <!-- WhatsApp -->
      <div class="notification-option-control">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div class="type-label"><i class="icon icon-whatsapp"></i></div>
          <div class="type-label">{{ 'NOTIFICATION-PREFERENCES.WHATS-APP' | translate }}</div>
        </div>
        <div>
          @if (hasRequiredFields.whatsAppAddress) {
            <topo-switch
            formControlName="use_whats_app_low"></topo-switch>
          } @else {
            <span [style.margin-right]="!isDesktop && '16px'">&mdash;</span>
          }
        </div>
      </div>
    </div>
  </div>
}


<ng-template #purpleCheck>
  <img
    src="/assets/images/purple-check.svg"
    style="height: 24px"
    [style.margin-right]="!isDesktop && '8px'" />
</ng-template>

